// extracted by mini-css-extract-plugin
export var actions = "_4z-0";
export var actionsContainer = "_4z-7";
export var border = "_4z-1";
export var childFullHeight = "_4z-f";
export var collapse = "_4z-2";
export var content = "_4z-a";
export var contentChild = "_4z-e";
export var fullscreen = "_4z-c";
export var hasLeftRadius = "_4z-k";
export var headerContainer = "_4z-3";
export var headerRow = "_4z-5";
export var hidePadding = "_4z-b";
export var navCollapsedGap = "_4z-l";
export var noScrollX = "_4z-m";
export var noScrollY = "_4z-n";
export var noTopPadding = "_4z-i";
export var optOutTopPadding = "_4z-d";
export var pageMain = "_4z-j";
export var pageOuter = "_4z-g";
export var pagePadding = "_4z-8";
export var pageScroll = "_4z-9";
export var profile = "_4z-o";
export var profileContainer = "_4z-p";
export var profileImage = "_4z-q";
export var profileMain = "_4z-r";
export var profileSubtitle = "_4z-t";
export var profileTitle = "_4z-s";
export var showLeftPadding = "_4z-h";
export var tabsPortalSlot = "_4z-6";
export var tabsWrapper = "_4z-4";
export var title = "_4z-u";